import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { RenderedService } from "../../rendered.service";
import { BaseScaffoldComponent } from "../base-scaffold/base-scaffold.component";
import { PreviewFrameService } from "../../../../tools/preview-frame/preview-frame.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "scaffold-file-link",
  templateUrl: "./file-link.component.html",
  styleUrls: ["../../rendered.component.scss", "./file-link.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileLinkComponent
  extends BaseScaffoldComponent
  implements OnInit, OnDestroy
{
  public destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public cdr: ChangeDetectorRef,
    public renderedService: RenderedService,
    private previewFrameService: PreviewFrameService
  ) {
    super(cdr, renderedService);
  }

  ngOnInit() {
    this.renderedService
      .listenForUpdates()
      .pipe(takeUntil(this.destroy$))
      .subscribe((trigger) => {
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  openFile(e: Event, file) {
    var title = "";
    title = this.item.value || this.item.text;

    e.preventDefault();
    // this.download_url = "/files/" + file;
    this.previewFrameService.openPreview(file,this.item, '',title);
    //var win = window.open(url, '_blank');
    /*setTimeout(i => {
      this.download_url = undefined;
    },2000)*/
  }
}
